import type { Eod } from "@/data/Eod.ts";
import { getZERSTELLUNG } from "@/tse/dsfinv/dsfinv-convert.ts";
import { masterDeviceSetting } from "@/data/utils/MasterDeviceSetting.ts";

export const Stamm_Kassen = {
  Z_KASSE_ID: {
      type: "string",
      maxLength: 50,
      hint: "ID der (Abschluss-) Kasse"
  },
  Z_ERSTELLUNG: {
      type: "datetime",
      hint: "Zeitpunkt des Kassenabschlusses"
  },
  Z_NR: {
      type: "number",
      places: 0,
      hint: "Nr. des Kassenabschlusses"
  },
  KASSE_BRAND: {
      type: "string",
      maxLength: 50,
      hint: "Marke der Kasse"
  },
  KASSE_MODELL: {
      type: "string",
      maxLength: 50,
      hint: "Modellbezeichnung"
  },
  KASSE_SERIENNR: {
      type: "string",
      maxLength: 70,
      hint: "Seriennummer der Kasse"
  },
  KASSE_SW_BRAND: {
      type: "string",
      maxLength: 50,
      hint: "Markenbezeichnung der Software"
  },
  KASSE_SW_VERSION: {
      type: "string",
      maxLength: 50,
      hint: "Version der Software"
  },
  KASSE_BASISWAEH_CODE: {
      type: "string",
      maxLength: 3,
      hint: "Basiswährung der Kasse",
      regex: "[A-Z]{3}"
  },
  KEINE_UST_ZUORDNUNG: {
      type: "boolean",
      hint: "UmsatzsteuerNichtErmittelbar"
  }
}

export function Stamm_KassenFactory(eod: Eod) {
  return build()
  function build() {
    return {
      Z_KASSE_ID: Z_KASSE_ID(),
      Z_ERSTELLUNG: Z_ERSTELLUNG(),
      Z_NR: Z_NR(),
      KASSE_BRAND: KASSE_BRAND(),
      KASSE_MODELL: KASSE_MODELL(),
      KASSE_SERIENNR: KASSE_SERIENNR(),
      KASSE_SW_BRAND: KASSE_SW_BRAND(),
      KASSE_SW_VERSION: KASSE_SW_VERSION(),
      KASSE_BASISWAEH_CODE: KASSE_BASISWAEH_CODE(),
      KEINE_UST_ZUORDNUNG: KEINE_UST_ZUORDNUNG()
    }
  }

  function Z_KASSE_ID() {
    // hint: "ID der (Abschluss-) Kasse",
    return masterDeviceSetting()?._id
  }

  function Z_ERSTELLUNG() {
    // hint: "Zeitpunkt des Kassenabschlusses",
    return getZERSTELLUNG(eod)
  }

  function Z_NR() {
    // hint: "Nr. des Kassenabschlusses",
    return eod.z;
  }

  //fixme: fill from surreal data
  //todo: tao 1 bang tren surreal: ghi thong tin KASSE_BRAND, KASSE_MODELL, KASSE_SW_BRAND
  //ten bang la CompanyInfo
  //CRUD, hoc cach tao user tren surreal
  function KASSE_BRAND() {
    // hint: "Marke der Kasse",
    return '';
  }

  function KASSE_MODELL() {
    // hint: "Modellbezeichnung",
    return '';
  }

  function KASSE_SERIENNR() {
    // hint: "Seriennummer der Kasse",
    return masterDeviceSetting()?._id;
  }

  function KASSE_SW_BRAND() {
    // hint: "Markenbezeichnung der Software",
    return '';
  }

  function KASSE_SW_VERSION() {
    // hint: "Version der Software",
    return '';
  }

  function KASSE_BASISWAEH_CODE() {
    // hint: "Basiswährung der Kasse",
    return 'EUR';
  }

  function KEINE_UST_ZUORDNUNG() {
    // hint: "UmsatzsteuerNichtErmittelbar",
    return '';
  }
}
